if($('.type-category').length){
    if($('.category-perex img[alt="levý obrázek"]').length){
        $('.category-perex').prepend($('h1.category-title'))
        $('.category-perex').addClass('haveImage').wrapInner('<div class="left"></div>')
        $('.category-perex').append($('.category-perex img[alt="levý obrázek"]').closest('p'))
    }
}